module.exports = __webpack_public_path__ + "media/audio3.c4a9335b.mp3";